import React from 'react';
import { cn } from '@/lib/cn';
import { CheckboxIcon } from '@/components/ui';

export interface AllBoroughOptionProps {
  borough: string;
  isSelected: boolean;
  onToggle: () => void;
  className?: string;
  leadingIcon?: React.ReactNode;
}

export const AllBoroughOption = React.memo(function AllBoroughOption({
  borough,
  isSelected,
  onToggle,
  className,
  leadingIcon,
}: AllBoroughOptionProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-4',
        'px-2 py-3',
        'rounded-xl',
        isSelected ? 'bg-active hover:bg-active-hover' : 'bg-primary hover:bg-primary-hover',
        'cursor-pointer',
        className,
      )}
      onClick={onToggle}
    >
      {leadingIcon ? (
        <div className="w-6 h-6 shrink-0 flex items-center justify-center">{leadingIcon}</div>
      ) : null}
      <div className="flex-1 min-w-0">
        <span className="text-body-2 text-primary">All {borough}</span>
      </div>
      <div className="shrink-0">
        <CheckboxIcon checked={isSelected} />
      </div>
    </div>
  );
});

export default AllBoroughOption;
